import { Flex, ScrollArea } from '@mantine/core';
import { MainColumn } from '../MainColumn';

export function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Flex h="calc(100vh - 120px - 32px)">
      <ScrollArea scrollbars="y" w="100%">
        <MainColumn>{children}</MainColumn>
      </ScrollArea>
    </Flex>
  );
}
